import { render, staticRenderFns } from "./MergeGuestHistory.vue?vue&type=template&id=05b40088&scoped=true&"
import script from "./MergeGuestHistory.vue?vue&type=script&lang=js&"
export * from "./MergeGuestHistory.vue?vue&type=script&lang=js&"
import style0 from "./MergeGuestHistory.vue?vue&type=style&index=0&id=05b40088&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b40088",
  null
  
)

export default component.exports